import { render, staticRenderFns } from "./customer-info-card.vue?vue&type=template&id=357f5180&scoped=true"
import script from "./customer-info-card.vue?vue&type=script&lang=js"
export * from "./customer-info-card.vue?vue&type=script&lang=js"
import style0 from "./customer-info-card.vue?vue&type=style&index=0&id=357f5180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357f5180",
  null
  
)

export default component.exports